import { SAVE_SELECTED_BRAND } from './actionTypes';

export function saveSelectedBrand(brandId) {
    return { type: SAVE_SELECTED_BRAND, selectedBrandId: brandId };
}